// import { request } from '@umijs/max';

/** 获取报告大纲 */
export const getMenus = (data?: any) => {
  // return request('', {
  //   method: 'POST',
  //   data: {
  //     ...data,
  //   },
  //   ...(options || {}),
  // });
  const treeData: any = [
    {
      path: '/welcome',
      name: '欢迎',
      icon: 'SmileOutlined',
    },
    {
      path: '/diagnosisReport',
      name: '诊断说明',
      icon: 'FileSearchOutlined'
    },
    {
      path: '/diagnosisOverview',
      name: '诊断总览',
      icon: 'BarChartOutlined'
    },
    {
      path: '/diagnosisDetail',
      name: '诊断详情',
      icon: 'DashboardOutlined',
      children: [
        {
          path: '/diagnosisDetail/customerManage',
          name: '客户管理',
        },
        {
          path: '/diagnosisDetail/pipelineManage',
          name: '商机管理',
        },
        {
          path: '/diagnosisDetail/businessRiskManage',
          name: '业务风险管理',
        },
        {
          path: '/diagnosisDetail/bpmManage',
          name: '业务审批与流程管理',
        },
      ],
    },
    {
      path: '/ask/chat',
      name: 'Chat',
      icon: 'CommentOutlined'
    },
    // {
    //   path: '/diagnosisOperateManage',
    //   name: '操作行为管理',
    //   icon: 'FormOutlined'
    // },
    // {
    //   path: '/diagnosisFiles',
    //   name: '附件',
    //   icon: 'FileSearchOutlined'
    // },
  ];

  const temData = {
    code: 0,
    msg: 'success',
    data: {
      records: [...treeData],
    },
  };
  return Promise.resolve(temData);
};
